import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import ClientQuota from "./ClientQuota";
import DockTab from "./DockTab";
import PlantQuota from "./PlantQuota";
import Plants from "./Plants";
import TurnTab from "./TurnTab";
import moment from "moment";

const ScheduleConfig = ({ branches, loadBranches, subRoutes}) => {
  const location = useLocation();

  const [filter, setFilter] = useState({
    branch: "",
    clientQuotasDate: moment(Date.now()).valueOf()
  });

  useEffect(() => {
    loadBranches();
  }, [loadBranches]);

  useEffect(() => {
    if (!filter.branch) {
      setFilter({
        clientQuotasDate: moment(Date.now()).valueOf()
      });
    }
  }, [filter.branch]);

  const renderTab = (pathname) => {
    switch (pathname) {
      case "/agendamento/configuracoes/turno":
        return (
          <TurnTab
            subRoutes={subRoutes}
            filter={filter}
            setFilter={setFilter}
            branches={branches}
          />
        );
      case "/agendamento/configuracoes/planta":
        return (
          <Plants
            subRoutes={subRoutes}
            filter={filter}
            setFilter={setFilter}
            branches={branches}
          />
        );
      case "/agendamento/configuracoes/docas":
        return (
          <DockTab
            subRoutes={subRoutes}
            filter={filter}
            setFilter={setFilter}
            branches={branches}
          />
        );
      case "/agendamento/configuracoes/cotaplanta":
        return (
          <PlantQuota
            subRoutes={subRoutes}
            filter={filter}
            setFilter={setFilter}
            branches={branches}
          />
        );
      case "/agendamento/configuracoes/cotacliente":
        return (
          <ClientQuota
            subRoutes={subRoutes}
            filter={filter}
            setFilter={setFilter}
            branches={branches}
          />
        );
      default:
        break;
    }
  };
  return <> {renderTab(location.pathname)} </>;
};

const mapStateToProps = ({
  cargillBranches: { branches },
  auth: {
    user: { groups },
  },
}) => {
  const subRoutes = [];

  (groups.indexOf("support") !== -1 ||
    (groups.indexOf("shift_manager") !== -1 &&
      groups.indexOf("backoffice") !== -1)) &&
    subRoutes.push({
      title: "Turno/Bloco",
      href: "/agendamento/configuracoes/turno",
    });

  (groups.indexOf("support") !== -1 ||
    (groups.indexOf("plant_manager") !== -1 &&
      groups.indexOf("backoffice") !== -1)) &&
    subRoutes.push({
      title: "Planta",
      href: "/agendamento/configuracoes/planta",
    });

  (groups.indexOf("support") !== -1 ||
    (groups.indexOf("dock_manager") !== -1 &&
      groups.indexOf("backoffice") !== -1)) &&
    subRoutes.push({
      title: "Docas",
      href: "/agendamento/configuracoes/docas",
    });

  (groups.indexOf("support") !== -1 ||
    (groups.indexOf("plant_quota_manager") !== -1 &&
      groups.indexOf("backoffice") !== -1)) &&
    subRoutes.push({
      title: "Cotas por Planta",
      href: "/agendamento/configuracoes/cotaplanta",
    });

  (groups.indexOf("support") !== -1 ||
    (groups.indexOf("client_quota_manager") !== -1 &&
      groups.indexOf("backoffice") !== -1)) &&
    subRoutes.push({
      title: "Cotas Cliente/Fornecedor",
      href: "/agendamento/configuracoes/cotacliente",
    });

  return {
    branches: branches.map((branch) => ({
      value: branch.id,
      label: branch.name,
    })),
    subRoutes,
    groups,
  };
};

const mapDispatch = (dispatch) => ({
  loadBranches: (payload) => dispatch.cargillBranches.loadAsync(payload),
});

ScheduleConfig.propTypes = {
  branches: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatch)(ScheduleConfig);
